export default "__VITE_ASSET__CF8TVVF3__"